import PropTypes from "prop-types";
import styles from "./ShowMoreButton.module.scss";
import PlusIcon from "../../assets/icons/plus_icon.svg";

const ShowMoreButton = ({
  numberOfSelections,
  selection,
  probability,
  competition,
  onClick,
}) => {
  return (
    <button type="button" className={styles.showMoreButton} onClick={onClick}>
      <div>
        <img src={PlusIcon} alt="Plus" />
      </div>
      <div>
        <span className={styles.showMoreNumber}>
          {numberOfSelections - 3} More:
        </span>{" "}
        {selection}, {competition}, {probability}%
      </div>
    </button>
  );
};

ShowMoreButton.propTypes = {
  numberOfSelections: PropTypes.number,
  selection: PropTypes.string,
  probability: PropTypes.number,
  competition: PropTypes.string,
  onClick: PropTypes.func,
};

export default ShowMoreButton;
